import { createContext, useContext } from 'react';
import type { SessionUser } from '@swg/contracts';

export const UserContext = createContext<SessionUser | null>(null);

export function useUser(): SessionUser {
  const user = useContext(UserContext);
  if (!user) {
    throw new Error('useUser buiten een ingelogde context gebruikt.');
  }
  return user;
}
